import { Test } from "../../../../models/test.model";

const BREEDING_TESTCODES = [
  "S5",
  "S6",
  "S7",
  "M5",
  "M6",
  "M7",
  "B5",
  "B6",
  "B7",
];

export const useIsBreeding = (test: Test) => {
  return BREEDING_TESTCODES.some((tc) => test.testName.startsWith(tc));
};
